module.exports = __webpack_public_path__ + "fonts/Faune-Text_Bold.82b7b0ed.otf";